import React, { useState } from 'react';
import Step1 from './steps/step1.tsx';
import Step2 from './steps/step2.tsx';
import Step3 from './steps/step3.tsx';

interface JDSetupProps {
    isLoggedIn: boolean;
}

interface JDData {
    businessInfo: {
        url?: string;
        description?: string;
    };
    jobDescription: string;
}

interface Step1Data {
    url?: string;
    description?: string;
    summary?: string;
}

interface Step2Data {
    jobDescription?: string;
}

const JDSetup: React.FC<JDSetupProps> = ({ isLoggedIn }) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [step1Data, setStep1Data] = useState<Step1Data>({});
    const [step2Data, setStep2Data] = useState<{ jobDescription: string }>({ jobDescription: '' });
    const [jdData, setJDData] = useState<JDData>({
        businessInfo: {},
        jobDescription: ''
    });

    const nextStep = () => setCurrentStep(prev => prev + 1);
    const prevStep = () => setCurrentStep(prev => prev - 1);

    const handleBusinessInfoSubmit = (data: { url?: string; description?: string }) => {
        setJDData(prev => ({
            ...prev,
            businessInfo: data
        }));
        nextStep();
    };

    const handleJDUpdate = (newJD: string) => {
        setJDData(prev => ({
            ...prev,
            jobDescription: newJD
        }));
    };

    return (
        <div className="max-w-4xl mx-auto p-6">
            <div className="mb-8">
                <div className="flex items-center justify-between">
                    <h1 className="text-2xl font-bold">Create Job Description</h1>
                    <div className="flex items-center">
                        <span className="text-sm text-gray-500">Step {currentStep} of 3</span>
                        <div className="ml-4 flex space-x-2">
                            {[1, 2, 3].map((step) => (
                                <div
                                    key={step}
                                    className={`h-2 w-2 rounded-full ${step === currentStep ? 'bg-blue-600' : 'bg-gray-300'
                                        }`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {currentStep === 1 && (
                <Step1
                    onSubmit={handleBusinessInfoSubmit}
                    setStep1Data={setStep1Data}
                />
            )}

            {currentStep === 2 && (
                <Step2
                    businessInfo={jdData.businessInfo}
                    jobDescription={jdData.jobDescription}
                    parsedContent={step1Data}
                    onJDUpdate={handleJDUpdate}
                    setStep2Data={setStep2Data}
                    onNext={nextStep}
                    onBack={prevStep}
                />
            )}

            {currentStep === 3 && (
                <Step3
                    jobDescription={jdData.jobDescription}
                    onBack={prevStep}
                />
            )}
        </div>
    );
};

export default JDSetup;